export default __webpack_public_path__ + "static/media/Menu@1.5xTD.3996783f.svg";